module.exports = __webpack_public_path__ + "img/Monte_Kope_10.e5e4c1df.jpg";